import React from 'react';
import { MegaphoneIcon } from '../icons/InterfaceIcons';

export const AnnouncementsCard = () => {
    return (
        <div className="bg-brand-surface border border-brand-border rounded-xl p-6 h-full shadow-card">
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-xl text-brand-text-primary">Announcements</h3>
                <MegaphoneIcon className="w-6 h-6 text-brand-text-secondary" />
            </div>
            <div className="flex items-center justify-center h-full -mt-8">
                 <p className="text-sm text-brand-text-secondary">No new announcements at this time.</p>
            </div>
        </div>
    );
};